import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Mail, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { Logo } from "../components/layout/Navbar";

export default function AdminForgotPasswordPage() {
  const [email, setEmail] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/forgot-password", { email });
      setSent(true);
      toast.success("Hvis emailen findes, har vi sendt et nulstillings-link");
    } catch {
      // Always show success-style feedback to avoid leaking which emails exist
      setSent(true);
      toast.success("Hvis emailen findes, har vi sendt et nulstillings-link");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg2 flex items-center justify-center p-5" data-testid="admin-forgot-page">
      <div className="w-full max-w-md">
        <div className="bg-white border border-brand p-8 sm:p-10">
          <Logo />
          <div className="kicker mt-7">Admin · Glemt password</div>
          <h1 className="font-display font-bold text-3xl text-brand-dark mt-2">Nulstil dit password</h1>

          {sent ? (
            <div className="mt-7 space-y-4" data-testid="admin-forgot-sent">
              <p className="text-brand-dark text-sm leading-relaxed">
                Hvis <b>{email}</b> matcher admin-kontoen, har vi sendt et nulstillings-link til din email.
                Linket udløber om 60 minutter.
              </p>
              <p className="text-xs text-gray-500">
                Tjek også din spam-mappe hvis du ikke modtager mailen indenfor få minutter.
              </p>
              <Link to="/admin/login" className="btn-secondary w-full justify-center" data-testid="admin-forgot-back-to-login">
                <ArrowLeft size={16} /> Tilbage til login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-forgot-form">
              <p className="text-sm text-brand-dark/80">
                Indtast admin-emailen. Vi sender dig et link til at vælge et nyt password.
              </p>
              <div>
                <label className="label-flat">Email</label>
                <input
                  type="email"
                  className="input-flat"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="admin-forgot-email"
                  required
                  autoFocus
                />
              </div>
              <button type="submit" className="btn-primary w-full justify-center" disabled={busy} data-testid="admin-forgot-submit">
                {busy ? <><Loader2 className="animate-spin" size={16} /> Sender...</> : <><Mail size={16} /> Send nulstillings-link</>}
              </button>
              <Link to="/admin/login" className="text-sm text-brand-dark/70 hover:underline block text-center pt-2" data-testid="admin-forgot-cancel">
                Tilbage til login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
